import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import DataTablePaginationPageSize from './DataTablePaginationPageSize';
import { DataTablePageSizeEnum } from '@/enums';
import { Button } from '@/components/ui';
import { useQueryParams } from '@/hooks';

type TProps = {
  changePageSize?: (newPageSize?: number) => void;
  changePage?: (newPage: number) => void;
  pageCount?: number;
  caption?: string;
}

export const DataTablePagination = ({ caption, pageCount, changePage, changePageSize }: TProps) => {

  const { values: [page, limit], setValue, deleteValue } = useQueryParams(['page', 'limit'], { page: 1, limit: DataTablePageSizeEnum._50 });

  const pageTitle = `${page === 0 ? 1 : page} sur ${pageCount ?? 1}`;
  const pageValue = parseInt(page);

  const handleChangePageSize = (newPageSize?: number) => {
    !newPageSize || newPageSize <= 0
      ? deleteValue('limit')
      : setValue('limit', newPageSize);

    changePageSize?.(newPageSize);
  };

  const handleChangePage = (newPage: number) => {
    setValue('page', newPage);

    changePage?.(newPage);
  };

  return (
    <div className='flex items-center justify-between'>
      <span className='text-sm text-muted-foreground'>
        {caption}
      </span>
      <div className='flex items-center space-x-5 md:space-x-10'>
        <DataTablePaginationPageSize
          limit={limit}
          onChange={handleChangePageSize} />
        {
          pageCount &&
          <>
            <p className='hidden md:block text-sm'>
              Page {pageTitle}
            </p>
            <p className='md:hidden text-sm'>
              {pageTitle}
            </p>
          </>
        }
        <div className='flex items-center space-x-2'>
          {/* Previous all */}
          {
            pageCount &&
            <Button
              disabled={pageValue === 1}
              onClick={() => handleChangePage(1)}
              title='Première page'
              className='h-8 w-8'
              variant={'outline'}
              size={'icon'}>
              <ChevronsLeft size={18} strokeWidth={2} />
            </Button>
          }
          {/* Previous */}
          <Button
            disabled={pageValue === 1}
            onClick={() => handleChangePage(pageValue - 1)}
            title='Page précédente'
            className='h-8 w-8'
            variant={'outline'}
            size={'icon'}>
            <ChevronLeft size={18} strokeWidth={2} />
          </Button>
          {/* Next */}
          <Button
            title='Page suivante'
            disabled={pageValue === pageCount}
            onClick={() => handleChangePage(pageValue + 1)}
            className='h-8 w-8'
            variant={'outline'}
            size={'icon'}>
            <ChevronRight size={18} strokeWidth={2} />
          </Button>
          {/* Next all */}
          {
            pageCount &&
            <Button
              title='Dernière page'
              disabled={pageValue === pageCount}
              onClick={() => handleChangePage(pageCount)}
              className='h-8 w-8'
              variant={'outline'}
              size={'icon'}>
              <ChevronsRight size={18} strokeWidth={2} />
            </Button>
          }
        </div>
      </div>
    </div>
  );

};

export default DataTablePagination;
